import { processingBillingConfigSchema } from "@redotech/redo-return-settings-common/processing-billing-config";
import { unaryRpc } from "@redotech/rpc/definition";
import * as z from "zod";

export const ProtectedSettingsAction = {
  bypassApproval: "bypassApproval",
  requestApproval: "requestApproval",
} as const;
export type ProtectedSettingsAction =
  (typeof ProtectedSettingsAction)[keyof typeof ProtectedSettingsAction];

/** The settings being saved. The handler runs putTeam's approval-diversion
 * guard, then mirrors the applied subtrees whole (Mongo-save parity). */
export const saveManagedReturnsSettings = unaryRpc({
  name: "saveManagedReturnsSettings" as const,
  input: z.object({
    teamId: z.string(),
    settings: z.object({
      redoManagedReturns: z.any().optional(),
      reFulfillment: z.any().optional(),
    }),
    billing: processingBillingConfigSchema.optional(),
    protectedSettingsAction: z
      .enum([
        ProtectedSettingsAction.bypassApproval,
        ProtectedSettingsAction.requestApproval,
      ])
      .optional(),
  }),
  output: z.object({ ok: z.literal(true) }),
});
